export const Orientation = {
    HORIZONTAL: 1,
    VERTICAL: 2,
};

export const Direction = {
    UP: "up",
    LEFT: "left",
    DOWN: "down",
    RIGHT: "right",
};

export const Level = {
    INFO: "info",
    PRIMARY: "primary",
    SECONDARY: "secondary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger",
    ERROR: "danger",
};

export const Size = {
    NONE: null,
    EXTRA_SMALL: "xs",
    SMALL: "sm",
    LARGE: "lg",
    EXTRA_LARGE: "xl",
};

export const VoteStatus = {
    NONE: null,
    LIKE: 1,
    DISLIKE: 0,
};

export const ActionStatus = {
    INITIAL: 1,
    RUNNING: 2,
    SUCCESS: 3,
    FAILED: 4,
};
